import { render } from "./Anchor.vue?vue&type=template&id=1b5ecd27&scoped=true"
import script from "./Anchor.vue?vue&type=script&lang=js"
export * from "./Anchor.vue?vue&type=script&lang=js"

import "./Anchor.vue?vue&type=style&index=0&id=1b5ecd27&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b5ecd27"]])

export default __exports__